/**
 * @author      Michael Hettmer <mail@michael-hettmer.de>
 * @copyright   2019 Plusbyte UG (haftungsbeschränkt)
 * @license     {@link https://plusbyte.de Plusbyte License}
 */

import React, { useCallback, useState } from 'react';

import { AuthDialog, ForgotPasswordDialog, useAuthDispatch, useAuthState } from '~/auth';

const AuthDialogManager = (): JSX.Element => {
  const { state: authState } = useAuthState();
  const authDispatch = useAuthDispatch();

  const [prefilledEmail, setPrefilledEmail] = useState('');
  const [prefilledPassword, setPrefilledPassword] = useState('');
  const [preFilledFirebaseIdToken, setPrefilledFirebaseIdToken] = useState<string>();
  const [showForgotPassword, setShowForgotPassword] = useState(false);

  const authMode: 'login' | 'register' = authState === 'register' ? 'register' : 'login';

  const resetAndCancel = useCallback(() => {
    authDispatch({ type: 'cancel' });
    setPrefilledEmail('');
    setPrefilledPassword('');
    setPrefilledFirebaseIdToken(undefined);
    setShowForgotPassword(false);
  }, [authDispatch]);

  const onOpenForgotPassword = () => {
    setShowForgotPassword(true);
  };

  const onBackToLoginFromForgotPassword = () => {
    setShowForgotPassword(false);
  };

  return (
    <>
      <AuthDialog
        key={`${authState}-${prefilledEmail}-${prefilledPassword}-${preFilledFirebaseIdToken ?? ''}`}
        modalOpen={(authState === 'login' || authState === 'register') && !showForgotPassword}
        initialMode={authMode}
        prefilledEmail={prefilledEmail}
        prefilledPassword={prefilledPassword}
        prefilledFirebaseIdToken={preFilledFirebaseIdToken}
        onLoginSuccess={resetAndCancel}
        onRegistrationSuccess={resetAndCancel}
        onCancelled={resetAndCancel}
        onForgotPassword={onOpenForgotPassword}
      />

      <ForgotPasswordDialog
        modalOpen={showForgotPassword}
        onBackToLogin={onBackToLoginFromForgotPassword}
      />
    </>
  );
};

export default AuthDialogManager;
